import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductInventoryBar extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBar);
    this.refreshInventoryFromApi();
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBar);
  }

  /** Fetch current inventory from product JSON (bypasses cached section HTML) */
  async refreshInventoryFromApi() {
    const handle = this.dataset.productHandle;
    const variantId = this.dataset.variantId;
    if (!handle || !variantId) return;

    try {
      const url = `/products/${handle}.js?inventory=${Date.now()}`;
      const res = await fetch(url, { cache: 'no-store' });
      if (!res.ok) return;
      const product = await res.json();
      const variant = product.variants?.find((v) => String(v.id) === String(variantId));
      if (!variant || variant.inventory_quantity == null) return;
      const qty = variant.inventory_quantity;

      if (qty <= 0) {
        this.classList.add('product-inventory-bar--hidden');
        delete this.dataset.inventoryQuantity;
        return;
      }

      this.classList.remove('product-inventory-bar--hidden');
      this.dataset.inventoryQuantity = String(qty);
      const fillPct = Math.min(100, qty);
      let textEl = this.querySelector('.product-inventory-bar__text');
      let fillEl = this.querySelector('.product-inventory-bar__fill');
      let inner = this.querySelector('.product-inventory-bar__inner');
      if (!inner) {
        inner = document.createElement('div');
        inner.className = 'product-inventory-bar__inner';
        const p = document.createElement('p');
        p.className = 'product-inventory-bar__text';
        p.setAttribute('role', 'status');
        p.setAttribute('aria-live', 'polite');
        const track = document.createElement('div');
        track.className = 'product-inventory-bar__track';
        track.setAttribute('role', 'presentation');
        const fill = document.createElement('div');
        fill.className = 'product-inventory-bar__fill';
        track.appendChild(fill);
        inner.appendChild(p);
        inner.appendChild(track);
        this.appendChild(inner);
        textEl = p;
        fillEl = fill;
      }
      if (textEl) {
        const one = qty === 1 ? '1 left' : `${qty} left`;
        textEl.textContent = `Only ${one} in stock`;
      }
      if (fillEl) fillEl.style.width = `${fillPct}%`;
    } catch (_) {}
  }

  updateBar = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBar = event.detail.data.html.querySelector('product-inventory-bar');

    if (!newBar) return;

    morph(this, newBar, { childrenOnly: true });
    this.className = newBar.className;
    this.dataset.variantId = newBar.dataset.variantId || this.dataset.variantId;
    this.dataset.inventoryQuantity = newBar.dataset.inventoryQuantity || '';
    this.refreshInventoryFromApi();
  };
}

if (!customElements.get('product-inventory-bar')) {
  customElements.define('product-inventory-bar', ProductInventoryBar);
}
